import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import { humanizeFieldName } from 'uplisting-frontend/helpers/humanize-field-name';

export function translateOrHumanize(
  intl: Services['intl'],
  prefix: string,
  value: string | undefined | null,
): string {
  if (!value) {
    return intl.t('words.n_a');
  }

  const key = `${prefix}.${value}`;

  return intl.exists(key) ? intl.t(key) : humanizeFieldName([value]);
}

export default class TranslateOrHumanizeHelper extends Helper {
  @service intl!: Services['intl'];

  compute([prefix, value]: [string, string | undefined | null]): string {
    return translateOrHumanize(this.intl, prefix, value);
  }
}
